export const formatDate = (data: any) => {
	const newdate = data.split('-').reverse().join('-');
	return new Date(newdate);
};
